import { Navigate, useRoutes } from 'react-router-dom';
// auth
import AuthGuard from '../auth/AuthGuard';
import MediatorGuestGuard from '../auth/MediatorGuard';

// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
// config
import { PATH_AFTER_MEDIATOR_LOGIN } from '../config-global';
//
import {
  MediatorLoginPage,
  Page404,
  ComingSoonPage,
  MediatorDashboardPage,
  BookingListPage,
  BookingViewPage,
  MediatorPage,
  FatturazionePage,
  // InvoiceCreate,
  InvoiceListPage,
  InvoiceDetailPage,
  TranslationOrdersPage,
} from './elements';
import RoleBasedGuard from '../auth/RoleBasedGuard';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <MediatorGuestGuard>
          <MediatorLoginPage />
        </MediatorGuestGuard>
      ),
    },

    // Mediator Dashboard
    {
      path: 'mediatore',
      element: (
        <AuthGuard type="mediator" roles={['mediator']}>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_MEDIATOR_LOGIN} replace />, index: true },
        {
          path: 'app',
          element: (
            <RoleBasedGuard hasContent roles={['mediator']} type="mediator">
              <MediatorDashboardPage />
            </RoleBasedGuard>
          ),
        },
        {
          path: 'richiesta',
          element: (
            <RoleBasedGuard hasContent roles={['mediator']} type="mediator">
              <BookingListPage />
            </RoleBasedGuard>
          ),
        },
        {
          path: 'richiesta/:id',
          element: (
            <RoleBasedGuard hasContent roles={['mediator']} type="mediator">
              <BookingViewPage />
            </RoleBasedGuard>
          ),
        },
        {
          path: 'fatturazione',
          element: (
            <RoleBasedGuard hasContent roles={['mediator']} type="mediator">
              <FatturazionePage />
            </RoleBasedGuard>
          ),
        },
        {
          path: 'profilo',
          element: (
            <RoleBasedGuard hasContent roles={['mediator']} type="mediator">
              <MediatorPage />
            </RoleBasedGuard>
          ),
        },
        {
          path: 'invoice',
          element: (
            <RoleBasedGuard hasContent roles={['mediator']} type="mediator">
              <InvoiceListPage />
            </RoleBasedGuard>
          ),
        },
        // {
        //   path: 'invoice-new',
        //   element: (
        //     <RoleBasedGuard hasContent roles={['mediator']} type="mediator">
        //       <InvoiceCreate />
        //     </RoleBasedGuard>
        //   ),
        // },
        {
          path: 'invoice/:id',
          element: (
            <RoleBasedGuard hasContent roles={['mediator']} type="mediator">
              <InvoiceDetailPage />
            </RoleBasedGuard>
          ),
        },
        {
          path: 'traduzioni',
          element: (
            <RoleBasedGuard roles={['mediator']} hasContent>
              <TranslationOrdersPage />
            </RoleBasedGuard>
          ),
        },
      ],
    },
    {
      element: <CompactLayout />,
      children: [
        // { element: <HomePage />, index: true },
        { path: 'coming-soon', element: <ComingSoonPage /> },
        { path: '404', element: <Page404 /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
